// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';
import { SEMIBOLD } from '../../../../../../helpers/fontWeight';

type ConfigPackageTitle = {
  active: boolean,
};
export const Title = styled<any, Theme, ConfigPackageTitle>('h3')`
  color: ${props => (props.active ? props.theme.optionPrice.titleColor.active : props.theme.optionPrice.titleColor.normal)};
  font-size: 1.125rem;
  font-weight: ${SEMIBOLD};
  margin-bottom: .5rem;
`;

type ConfigPackagePrice = {
  active: boolean,
};
export const StyledPrice = styled<any, Theme, ConfigPackagePrice>('div')`
  color: ${props => (props.active ? props.theme.optionPrice.priceColor.active : props.theme.optionPrice.priceColor.normal)};
  font-size: .875rem;
  line-height: 1;
`;

type ConfigPackageContent = {
  variant: string,
};
export const Content = styled<any, Theme, ConfigPackageContent>('section')`
  flex-grow: 1;
  flex-shrink: 0;
  text-align: ${props => (props.variant === 'small' ? 'left' : 'center')};
`;

type ConfigPackageImage = {
  variant: string,
};
export const Image = styled<any, Theme, ConfigPackageImage>('img')`
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: .5rem;
  max-height: 5rem;
  width: 5rem;
  left: ${props => (props.variant === 'small' ? '0' : '50%')};
  position: relative;
  transform: ${props => (props.variant === 'small' ? 'translateX(0)' : 'translateX(-50%)')};
`;
